{
  "generel": {
    "yes": "Yes",
    "no": "No"
  },
  "actions": {
    "cancel": "Cancel",
    "choose_images": "You may choose one or more image to add to this entry.",
    "choose_image": "Add an image to this entry.",
    "choose_camera": "Camera",
    "choose_photo": "Choose an image",
    "choose_library": "Library",
    "delete": "Delete",
    "dont_show_again": "Don't show again",
    "edit": "Edit",
    "edit_details": "Edit details",
    "next": "Next",
    "ok": "OK",
    "previous": "Previous",
    "show": "View",
    "submit": "Submit",
    "take_picture": "Take a Picture",
    "use_slider": "Use the slider",
    "abort": "Abort",
    "close": "Close",
    "more": "Load more",
    "back": "Back",
    "update_available": "New version available, click on reload button to update.",
    "reload": "Reload"
  },
  "table": {
    "rowsPerPage": "Rows per page",
    "pageOf": "of"
  },
  "admin": {
    "dashboard": "Dashboard",
    "menu": "Menu"
  },
  "menu": {
    "admin": "Administration",
    "map": "Map",
    "user": "User",
    "profil": "Preferences",
    "statistic": "Statistic",
    "form": "Notification",
    "my-locations": "My vacencies",
    "content": "Informationen/Inhalte",
    "detail": "Vacancy",
    "news": "News",
    "article": "Articel",
    "form_edit": "Edit vacancy",
    "styleguide": "Styleguide",
    "content_menu": {
      "about": "About the project",
      "about-project": "Vacancy radar",
      "about-network": "Network",
      "about-history": "Formation and history",
      "about-opensource": "Open source",
      "about-partner": "Our partners",
      "claim": "Our demands",
      "claim-general": "Gerenal",
      "claim-regional": "Regional",
      "definition": "What is vacancy",
      "definition-definition": "Definition",
      "definition-legal": "Legal situation",
      "definition-term": "Terms of cities & regions",
      "definition-reasons": "Reasons for vacancy",
      "definition-harm": "Warum Leerstand schadet",
      "definition-spot": "Wie erkenne ich Leerstand",
      "perspective": "Perspectivs",
      "perspective-experience": "Experience",
      "perspective-theory": "Theory",
      "howto": "How to",
      "demands": "Our demands",
      "glossar": "Glossar & Perspectivs",
      "participate": "Participate",
      "participate-how": "How to participate?",
      "participate-material": "Material",
      "participate-idea": "Ideas",
      "participate-donation": "Donation",
      "press": "Press",
      "help": "Help & Support",
      "support": "Help & Support",
      "support-howto": "So geht's",
      "support-faq": "FAQ",
      "support-goodtoknow": "Good to know",
      "contact": "Contact",
      "contact-contact": "Contact",
      "contact-dataprotection": "Data protection",
      "contact-terms": "Terms",
      "contact-imprint": "Imprint"
    },
    "admin_menu": {
      "regions": "Regions",
      "users": "Users"
    }
  },
  "asset": {
    "file": "Datei"
  },
  "author": {
    "author": "Author",
    "by": "by",
    "created": "Created",
    "in": "in",
    "on": "on",
    "updated": "Updated"
  },
  "captcha": {
    "enter_captcha": "Enter the code"
  },
  "comments": {
    "all": "Comments",
    "manage_comments": "Manage comments",
    "comment": "Comment",
    "comment_plural": "Comments",
    "comment_text": "Comment text",
    "new_comment": "New Comment",
    "new_comment_login": "Log in to post a new comment.",
    "no_comments": "No Comments",
    "body": "Message",
    "hidden": "Hide comment",
    "created": "Created"
  },
  "creator": {
    "tabs": {
      "admin": "Admin",
      "details": "Details",
      "info": "Info",
      "location": "Location",
      "preview": "Preview"
    }
  },
  "errors": {
    "access_denied": "You are not allowed to perform this action.",
    "authorization_failed": "Login failed.",
    "location": {
      "no_data": "Location could not be loaded."
    },
    "region": {
      "no_data": "Region could not be loaded."
    },
    "unknown": "An unknown error occurred.",
    "noconnection": "The app could not reach the server. Try again later.",
    "critical": {
      "title": "Critical error",
      "resolve": "Ok, try again?"
    },
    "users": {
      "confirmation_failed": "Confirmation failed. This link might already be used.",
      "email_exists": "This email is already registered.",
      "invalid_email": "Invalid email.",
      "password_confirm_mismatch": "Passwords do not match.",
      "password_too_short": "Password is too short (min. 8 characters).",
      "reset_failed": "Password reset failed. This link is invalid and may have already been used.",
      "too_many_failed_logins": "Too many failed logins. Please try again in five minutes."
    }
  },
  "successes": {
    "user": {
      "login": "You are now logged in.",
      "logout": "You have been logged out."
    }
  },
  "photos": {
    "remove_confirm_title": "Delete image?",
    "remove_confirm_body": "Are you sure that you want to delete this image?",
    "remove_success": "Image has been deleted."
  },
  "locations": {
    "manage_locations": "Manage locations",
    "new_locations": "Neuste Leerstände",
    "notification": "Meldung",
    "status": "Aktueller Stand",
    "error": "Allgemeiner Fehler: ",
    "saved": "Leerstand gespeichert",
    "restart_explain": "Dein Eintrag wurde gespeichert. Bitte ergänze den Eintrag noch mit weiteren Informationen und füge auch Bilder hinzu.",
    "restart": "Weiteren Eintrag anlegen",
    "location_create": "Leerstand eintragen",
    "location_exists": "Gemeldeter Leerstand",
    "location_not_exists": "Neue Adresse",
    "location_edit_existing": "Bestehenden Eintrag ergänzen",
    "create_explain_1": "Gib hier eine Adresse ein...",
    "create_explain_2": "Um einen Leerstand einzutragen muss du eine Adresse angeben. Nutze dafür das Suchfeld oder verschiebe die Karte.",
    "create_explain_or": "ODER",
    "create_explain_3": "... oder bewege die Karte um einen Adresse zu suchen",
    "create_explain_4": "Ihr könnt auch die Karte verwenden um eine Adresse auswählen.",
    "image_upload": "Bilder hochladen (optional)",
    "additional_information": "Weitere Informationen (optional)",
    "status_entry": {
      "vacancy": "Vacancy",
      "damage": "Demolished",
      "reconstruction": "New building",
      "alive": "Inhabited",
      "temporary": "Interim use",
      "construction": "Construction",
      "unknown": "Unclear condition",
      "undefined": "undefined"
    },
    "stepper": {
      "step1": "Enter address",
      "step2": "Upload images / Further information",
      "step3": "Preview / Summary"
    },
    "status_explain": "Wie ist der aktuelle Status zu dem Leerstand",
    "timeline_explain": "Hier siehst du die Entwicklung des Status",
    "address": "Address",
    "building_type": "Building Type",
    "building_type_options": {
      "residential": "Residential",
      "commercial": "Commercial",
      "industrial": "Industrial",
      "historical": "Historical",
      "public_work": "Public Work",
      "other": "Other"
    },
    "city": "City",
    "create_new": "Submit location",
    "degree": "Degree of Emptiness",
    "degree_options": {
      "complete": "Complete",
      "partial": "Partial"
    },
    "description": "Description",
    "demolished": "Demolished",
    "demolished_yes": "Yes",
    "demolition_options": {
      "rumor": "Rumored",
      "demolished": "Demolished"
    },
    "demolition_rumor": "Rumors of Demolition",
    "demolition_rumor_yes": "Yes",
    "edit": "Edit Location",
    "empty_for": "Empty for",
    "empty_options": {
      "recently": "just recently",
      "min_five_years": "at least 5 years",
      "min_three_years": "at least 3 years",
      "min_one_year": "at least a year",
      "about_half_year": "about half a year",
      "less_than_one_quarter_year": "less than one quarter of 1 year",
      "less_than_one_half_year": "less than one half of 1 year",
      "less_than_three_quarters_year": "less than three quarters of 1 year",
      "less_than_one_year": "less than 1 year",
      "more_than_ten_years": "more than 10 years",
      "one_quarter": "one quarter",
      "one_half": "one half",
      "three_quarters": "three quarters",
      "year": "year",
      "year_plural": "years",
      "and": "and"
    },
    "help": {
      "info": "Enter a descriptive title and a description for this location.",
      "location": "Enter an address and the map should update after a short moment. You can drag the marker on the map to update the address.",
      "details": "Fill out those details that you know about the location. If you do not know something, just leave it blank.",
      "admin": "Set this Asset to \"Hidden\" to prevent non-administrators from seeing it."
    },
    "hidden": "Hidden",
    "hidden_yes": "Yes",
    "hidden_moderation": "This location will not be displayed right now. Contact your locale LM crew to display this entry",
    "location": "Location",
    "location_photos": "Photos for this location",
    "location_plural": "Locations",
    "locations_by_region": "Locations by Region",
    "my_locations": "My Locations",
    "no_recent_activity": "No Recent Activity",
    "none_found": "No locations found.",
    "owner": "Owner",
    "owner_options": {
      "private": "Private",
      "business": "Business",
      "public": "Public",
      "city": "City"
    },
    "postcode": "Postal code",
    "recent_activity": "Latest Activity",
    "remove_confirm_title": "Delete Location",
    "remove_confirm_body": "This action cannot be undone. Are you sure?",
    "remove_success": "Location deleted",
    "search": "Search",
    "street": "Street",
    "title": "Title",
    "unknown": "Unknown"
  },
  "messages": {
    "introduction_explain_headline": "Make vacancies in your city visible with us",
    "introduction_explain_content": "Find and report vacancies in your region",
    "introduction_explain_content_alt": "Become a vacancy reporter",
    "regions_map_intro": "From Amsterdam to Wuppertal, all vacancies at a glance:",
    "staging_message": "This is a test/staging enviroment. Please do not add data as it will be deleted. To register vacancy please use our productiv side: https://leerstandsmelder.de",
    "answer_message": "Reply to Message",
    "create_message": "Create Message",
    "message": "Message",
    "message_text": "Message text",
    "my_messages": "Messages",
    "sent": "Sent",
    "to": "To",
    "from": "From",
    "comments": {
      "create_success": "Comment successfully posted."
    },
    "locations": {
      "create_success": "Location created successfully.",
      "update_success": "Leerstand updated successfully."
    },
    "users": {
      "confirmation_success": "Successfully confirmed! You are now logged in.",
      "create_success": "Your registration was successful. Please check your emails for the confirmation link!",
      "request_reset_success": "Password reset requested. You should now get an email containing a link to reset your password.",
      "reset_success": "You are now logged in and may change your password.",
      "update_success": "Account was successfully updated."
    },
    "login": {
      "failed_authentication": "Your login could not be verified. Our system uses a new encryption. Please change your password through our 'Forgot password' process "
    }
  },
  "popups": {
    "relaunch": {
      "title": "Relaunch!"
    }
  },
  "posts": {
    "edit_post": "Edit Post",
    "manage_posts": "Manage Posts",
    "post": "Post",
    "post_plural": "Posts",
    "site_post_plural": "Page content",
    "title": "Title",
    "update_success": "Post updated successfully.",
    "create_post": "Create post",
    "slug": "Slug URL",
    "static": "Static side"
  },
  "news": {
    "new_articles": "News"
  },
  "regions": {
    "settings": "Settings",
    "hide_message": "Message if Region is hidden",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "manage_regions": "Manage Regions",
    "create_regions": "Create region",
    "region": "Region",
    "region_plural": "Regions",
    "region_detail": "Show region",
    "region_select": "Select region",
    "set_hide": "Hide this Region",
    "set_moderate": "Moderate this Region",
    "title": "Title",
    "load_success": "Region successfully loaded",
    "update_success": "Region updated successfully.",
    "update_error": "Region could not been updated",
    "create_success": "Region successfully created",
    "create_error": "Region konnte nicht erstellt werden",
    "zoom": "Zoom",
    "count": "Count",
    "created": "Created",
    "updated": "Updated",
    "filter": "Filter / Timeline",
    "location_explain": "Hier kann der Standort und Mittelpunkt der Region ausgewählt werden",
    "additional_information": "Weitere Informationen",
    "subtitle_explain": "Hier kann ein Untertitel für die Region angegeben werden",
    "subtitle": "Untertitel",
    "description_explain": "Hier kann ein Beschreibung für die Region angegeben werden",
    "description": "Beschreibung",
    "moderations": "Einstellungen zur Moderation",
    "moderate_message": "Nachricht, wenn eine Leerstand in einer moderierten Region eingestellt wird und erst durch die Moderation freigeschaltet werden muss.",
    "legal": "Rechtliche Struktur und Hintergünde",
    "legal_explain": "Hier können INformationen zur juristisch zuständigen Orgaisation oder Person hinterlegt werden.",
    "organisation": "Name der verantwortlichen Organisation/Person",
    "organisation_email": "Kontakt-Email",
    "organisation_url": "Kontakt-Link",
    "organisation_address": "Kontakt-Adresse",
    "organisation_legal_explain": "Weiterführende Informationen zur rechtlichen Vertretung",
    "organisation_legal": "Rechtliche Vertretung",
    "organisation_intro_explain": "Weitere Informationen zur Vorstellung der Organisation",
    "organisation_intro": "Vorstellung der Organisation",
    "organisation_meeting_explain": "Text zum Einladen von Vernetzungstreffen",
    "organisation_meeting": "Einladung zu Treffen",
    "organisation_meeting_intro": "Besucht unsere Treffen: ",
    "organisation_home_intro": "Der Leerstandsmelder in {lsm_name} wird betreut von:",
    "missing": {
      "title": "Where are you?",
      "intro": "Help us to assign your message by first selecting a region:"
    },
    "map_lists": {
      "next": "Vacancies in the map section",
      "next_short": "In the map section",
      "newest": "Newly registered vacancies",
      "newest_short": "New entries",
      "filter": "Filter vacancies",
      "filter_short": "Filter vacancies",
      "need": "Vacancies about which information is missing",
      "need_short": "Needs information",
      "need_alt": "Go by"
    }
  },
  "site": {
    "name": "Vacancy radar",
    "name_neutral": "Vacancy radar",
    "name_short": "Void",
    "banned": "Banned",
    "copyright_notice": "© 2024 Leerstandsmelder.de",
    "map_notice": "Maps: © OpenStreetMap contributors, ODbL 1.0.",
    "lang": "Language",
    "lang_de": "German",
    "lang_en": "English",
    "lang_nl": "Dutch",
    "latest_posts": "Recent Posts",
    "no_latest_posts": "No Recent Posts",
    "no": "No",
    "subnav": {
      "home": "Home",
      "information": "Information",
      "about": "About",
      "developers": "Developers",
      "feedback": "Feedback",
      "howto": "Howto",
      "imprint": "Imprint",
      "index": "City index",
      "press": "Press",
      "terms": "Terms",
      "dataprotection": "Data protection",
      "region": "Region"
    },
    "title": "Leerstandsmelder"
  },
  "users": {
    "manage_users": "Manage users",
    "create_user": "Create user",
    "admin_edit": "Edit user",
    "admin_create": "Create user",
    "anonymous": "Not logged in",
    "email": "Email",
    "forgot": "Forgot Password",
    "forgot_enter_email": "Please enter your email address",
    "enter_email": "Enter email address",
    "request_password": "Request password",
    "pwd_change": "Change password",
    "reset": "Reset password",
    "enter_new_password": "Please enter a new password.",
    "logout": "Logout",
    "password": "Password",
    "password_enter": "Enter password!",
    "password_confirm": "Confirm Password",
    "password_submit": "Submit password",
    "destroy": "Delete account",
    "destroy_intro": "You can delete your account at any time and thus stop using the vacancy radar. All your personal data will be deleted.",
    "destroy_headline": "Delete account",
    "destroy_explain": "If you want to delete your account, all personal data will be removed. This includes your user name and email address. The vacancies and comments you have reported are not subject to objection and will be retained.",
    "destroy_finally": "Delete irrevocably",
    "destroy_abort": "Cancel deletion",
    "settings": "Settings",
    "profile": "Profile",
    "signup": "Sign up",
    "username": "Username",
    "login_process": "Registration",
    "login_process_explain": "You have to register to take part.",
    "login_no_account": "If you don't have an account yet, click here for the ",
    "login": "Login",
    "message_me": "Other Users can send me messages via Leerstandsmelder.",
    "notify": "Send me an Email when my entries are updated or other users send me a message.",
    "share_email": "Make my email address visible to other users",
    "register_process": "Join in",
    "register": "Sign up",
    "register_headline": "Create account",
    "register_process_explain": "In order to publish new entries on the vacancy notifier, but also to submit new comments/status reports on existing entries, you must create an account. We will ask for your e-mail address. We try to store as little data about you as possible. We encourage you to use our service under a pseudonym. You can choose a pseudonym for your user name. Your email address should not contain any inference to your name.",
    "register_already_account": "If you already have an account, you can go to the ",
    "register_message": "Register now!",
    "all": "All users",
    "confirmed": "Confirmed",
    "blocked": "Blocked",
    "last_login": "Last login",
    "failed_logins": "Failed logins",
    "scope": "Scopes",
    "created": "Created",
    "accept_no_minor": "I assure you that I am over 18 years old.",
    "accept_terms": "I have read the terms of service and accept these terms.",
    "terms": "Terms of service",
    "update": "Update",
    "user_loaded": "Settings have been loaded",
    "user_places_loaded": "Entries have been loaded",
    "user_comments_loaded": "Comments have been loaded",
    "no_locations": "No entries available",
    "no_comments": "No comments available"
  },
  "content": {
    "about": {
      "headline": "You can find more information here:",
      "what": "What is the vacancy radar?",
      "why": "Why is vacancy harmful?",
      "claim": "What are our demands?",
      "how": "How can you take part?",
      "goodtoknow": "Interesting facts about vacancies"
    }
  }
}
